{
  "INBOX_MGMT": {
    "HEADER": "Источники",
    "DESCRIPTION": "Канал — это способ коммуникации, который ваш клиент выбирает для связи с вами. Входящие — это место, где вы управляете диалогами для определенного канала. Он может включать диалоги из различных источников, таких как электронная почта, онлайн чат или социальные сети.",
    "LEARN_MORE": "Узнать больше о «Входящих»",
    "RECONNECT": {
      "BUTTON": "Подключить заново",
      "FACEBOOK": "Срок действия подключения к Facebook истёк, или его отозвали. Сообщения на страницу не попадают в этот источник, и ответы могут не отправиться. Человек, который управляет страницей Facebook, должен нажать «Подключить заново» и войти в Facebook.",
      "INSTAGRAM": "Срок действия подключения к Instagram истёк, или его отозвали. Сообщения на аккаунт не попадают в этот источник, и ответы могут не отправиться. Нажмите «Подключить заново» и войдите в тот же аккаунт Instagram. Другой аккаунт создаст новый источник.",
      "GOOGLE": "Срок действия подключения к Google истёк, или его отозвали. Новые письма не попадают в этот источник, и ответы могут не отправиться. Нажмите «Подключить заново» и войдите в Google как {email}.",
      "MICROSOFT": "Срок действия подключения к Microsoft истёк, или его отозвали. Новые письма не попадают в этот источник, и ответы могут не отправиться. Нажмите «Подключить заново» и войдите в Microsoft как {email}.",
      "ALLEGRO": "Срок действия подключения к Allegro истёк, или его отозвали. Сообщения от покупателей не попадают в этот источник, и ответы могут не отправиться. Нажмите «Подключить заново» и войдите в Allegro как продавец {seller}. Другой аккаунт продавца создаст новый источник.",
      "IMAP_LOGIN": "Почтовый сервер отклоняет логин IMAP {login}. Новые письма в этот ящик не поступают. Проверьте логин и пароль IMAP на вкладке {tab} и сохраните их. Мы продолжаем пытаться войти, и ящик восстановится, как только вход заработает.",
      "WHATSAPP": "Подключение к WhatsApp истекло или было отозвано. Вложения от клиентов не поступают в этот почтовый ящик, а ответы могут не отправляться. Нажмите «Подключить заново», войдите в Facebook и снова выберите номер {phone}."
    },
    "LIST": {
      "404": "У вас пока нет источников.",
      "RECONNECT_REQUIRED": "Требуется повторное подключение"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Выберите источник",
        "BODY": "Выберите канал, который вы хотите подключить к чату."
      },
      "INBOX": {
        "TITLE": "Создать источник",
        "BODY": "Авторизуйте свой аккаунт и создайте ящик."
      },
      "AGENT": {
        "TITLE": "Добавить операторов",
        "BODY": "Добавить агента в созданный источник."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Все готово!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Имя источника",
        "PLACEHOLDER": "Введите имя папки \"Входящие\" (например: Acme Inc)",
        "ERROR": "Пожалуйста, введите правильное имя"
      },
      "WEBSITE_NAME": {
        "LABEL": "Имя сайта",
        "PLACEHOLDER": "Введите имя вашего сайта (например: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Внутреннее название",
        "PLACEHOLDER": "Название источника, отображаемое в этой панели управления",
        "ERROR": "Пожалуйста, введите уникальное внутреннее название"
      },
      "FB": {
        "HELP": "PS: После авторизации мы получим доступ только к вашим сообщениям на странице. Ваши личные сообщения нам никогда не доступны.",
        "CHOOSE_PAGE": "Выберите страницы",
        "CHOOSE_PLACEHOLDER": "Выберите страницу из списка",
        "INBOX_NAME": "Имя источника",
        "ADD_NAME": "Введите имя источника",
        "PICK_NAME": "Выберите имя для папки \"Входящие\"",
        "PICK_A_VALUE": "Выберите значение",
        "CREATE_INBOX": "Создать источник"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Продолжить с Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Подключите свой профиль Instagram",
        "HELP": "Чтобы добавить свой профиль Instagram как канал, вам нужно подтвердить его, нажав «Продолжить с Instagram» ",
        "ERROR_MESSAGE": "Произошла ошибка при подключении к Instagram, попробуйте ещё раз",
        "ERROR_AUTH": "Произошла ошибка при подключении к Instagram, попробуйте ещё раз",
        "NEW_INBOX_SUGGESTION": "Этот аккаунт Instagram ранее был привязан к другому источнику и теперь перенесён сюда. Все новые сообщения будут появляться здесь. Прежний источник больше не сможет отправлять и получать сообщения для этого аккаунта.",
        "DUPLICATE_INBOX_BANNER": "Этот аккаунт Instagram был перенесён в новый источник канала Instagram. Вы больше не сможете отправлять и получать сообщения Instagram через этот источник."
      },
      "TWITTER": {
        "HELP": "Чтобы добавить свой Twitter профиль в качестве источника, вам нужно авторизоваться при помощи входа через Twitter ",
        "ERROR_MESSAGE": "Произошла ошибка при подключении к Twitter, попробуйте еще раз",
        "TWEETS": {
          "ENABLE": "Создать беседы из твитов с упоминанем"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Сайт",
        "DESC": "Создайте источник для вашего сайта и начните поддерживать клиентов через виджет на сайте.",
        "LOADING_MESSAGE": "Подключение сайта в качестве источника",
        "CHANNEL_AVATAR": {
          "LABEL": "Изображение"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL вебхука",
          "PLACEHOLDER": "Введите URL-адрес вебхука",
          "ERROR": "Пожалуйста, введите правильный URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Домен сайта",
          "PLACEHOLDER": "Введите домен вашего сайта (например: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Заголовок приветствия",
          "PLACEHOLDER": "Привет!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Текст приветствия",
          "PLACEHOLDER": "Связаться с нами просто! Напишите нам, или задайте вопрос."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Сообщение-приветствие",
          "PLACEHOLDER": "Acme Inc обычно отвечает в течение нескольких часов."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Включить приветствие",
          "HELP_TEXT": "Автоматически отправлять приветственное сообщение при создании нового диалога.",
          "ENABLED": "Включено",
          "DISABLED": "Выключено"
        },
        "REPLY_TIME": {
          "TITLE": "Установить время ответа",
          "IN_A_FEW_MINUTES": "Через несколько минут",
          "IN_A_FEW_HOURS": "Через несколько часов",
          "IN_A_DAY": "Через день",
          "HELP_TEXT": "Это время ответа будет отображаться в виджете онлайн чата"
        },
        "WIDGET_COLOR": {
          "LABEL": "Цвет виджета",
          "PLACEHOLDER": "Изменить цвет виджета"
        },
        "SUBMIT_BUTTON": "Создать источник",
        "API": {
          "ERROR_MESSAGE": "Не удалось создать канал сайта, попробуйте еще раз"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp канал",
        "DESC": "Интегрируйте Twilio и начните поддерживать ваших клиентов через SMS или Whatsapp.",
        "ACCOUNT_SID": {
          "LABEL": "SID аккаунта",
          "PLACEHOLDER": "Пожалуйста, введите SID вашего аккаунта Twilio",
          "ERROR": "Это поле обязательно"
        },
        "API_KEY": {
          "USE_API_KEY": "Использовать API ключ аутентификации",
          "LABEL": "API Ключ SID",
          "PLACEHOLDER": "Пожалуйста, введите ваш ключ API SID",
          "ERROR": "Это поле обязательно"
        },
        "API_KEY_SECRET": {
          "LABEL": "Секретный ключ API",
          "PLACEHOLDER": "Пожалуйста, введите секретный ключ API",
          "ERROR": "Это поле обязательно"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID службы обмена сообщениями",
          "PLACEHOLDER": "Пожалуйста, введите SID службы сообщений Twilio",
          "ERROR": "Это поле обязательно",
          "USE_MESSAGING_SERVICE": "Использовать сервис Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Тип источника",
          "ERROR": "Пожалуйста, выберите тип источника"
        },
        "AUTH_TOKEN": {
          "LABEL": "Токен авторизации",
          "PLACEHOLDER": "Пожалуйста, введите ваш Токен аутентификации Twilio",
          "ERROR": "Это поле обязательно"
        },
        "CHANNEL_NAME": {
          "LABEL": "Имя источника",
          "PLACEHOLDER": "Пожалуйста введите имя канала",
          "ERROR": "Это поле обязательно"
        },
        "PHONE_NUMBER": {
          "LABEL": "Номер телефона",
          "PLACEHOLDER": "Введите номер телефона, с которого будет отправлено сообщение.",
          "ERROR": "Пожалуйста, укажите действительный номер телефона, который начинается с знака «+» и не содержит пробелов."
        },
        "API_CALLBACK": {
          "TITLE": "URL",
          "SUBTITLE": "Вы должны настроить URL колбеков в Twilio с этим URL."
        },
        "SUBMIT_BUTTON": "Создать источник Twilio",
        "API": {
          "ERROR_MESSAGE": "Мы не смогли авторизоваться в Twilio. Пожалуйста, попробуйте еще раз"
        }
      },
      "SMS": {
        "TITLE": "SMS-канал",
        "DESC": "Начните поддерживать ваших клиентов с помощью SMS.",
        "PROVIDERS": {
          "LABEL": "Поставщик API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Не удалось сохранить SMS-канал"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID аккаунта",
            "PLACEHOLDER": "Пожалуйста, введите ваш идентификатор аккаунта Bandwidth",
            "ERROR": "Это поле обязательно"
          },
          "API_KEY": {
            "LABEL": "Ключ API",
            "PLACEHOLDER": "Пожалуйста, введите ваш Bandwith API Key",
            "ERROR": "Это поле обязательно"
          },
          "API_SECRET": {
            "LABEL": "Секретный ключ API",
            "PLACEHOLDER": "Пожалуйста, введите ваш Bandwith API Secret",
            "ERROR": "Это поле обязательно"
          },
          "APPLICATION_ID": {
            "LABEL": "ID приложения",
            "PLACEHOLDER": "Пожалуйста, введите ваш ID аккаунта Bandwidth",
            "ERROR": "Это поле обязательно"
          },
          "INBOX_NAME": {
            "LABEL": "Имя источника",
            "PLACEHOLDER": "Пожалуйста введите имя канала",
            "ERROR": "Это поле обязательно"
          },
          "PHONE_NUMBER": {
            "LABEL": "Номер телефона",
            "PLACEHOLDER": "Введите номер телефона, с которого будет отправлено сообщение.",
            "ERROR": "Пожалуйста, укажите действительный номер телефона, который начинается с знака «+» и не содержит пробелов."
          },
          "SUBMIT_BUTTON": "Создать канал Bandwidth",
          "API": {
            "ERROR_MESSAGE": "Мы не смогли авторизоваться в Bandwidth. Пожалуйста, попробуйте еще раз"
          },
          "API_CALLBACK": {
            "TITLE": "URL",
            "SUBTITLE": "Вы должны настроить URL колбеков в Bandwidth используя этот URL."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Название источника",
            "PLACEHOLDER": "Пожалуйста, введите название источника",
            "ERROR": "Это поле обязательно"
          },
          "PHONE_NUMBER": {
            "LABEL": "Номер телефона",
            "PLACEHOLDER": "Пожалуйста, введите номер телефона, с которого будут отправляться сообщения.",
            "ERROR": "Пожалуйста, укажите корректный номер телефона, начинающийся со знака `+`."
          },
          "SUBMIT_BUTTON": "Создать канал SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Не удалось создать канал SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Название источника",
            "PLACEHOLDER": "Пожалуйста, введите название источника",
            "ERROR": "Это поле обязательно"
          },
          "PHONE_NUMBER": {
            "LABEL": "Номер телефона",
            "PLACEHOLDER": "Пожалуйста, введите номер телефона, с которого будут отправляться сообщения.",
            "ERROR": "Пожалуйста, укажите корректный номер телефона, начинающийся со знака `+`."
          },
          "SUBMIT_BUTTON": "Создать канал DIDWW",
          "API": {
            "ERROR_MESSAGE": "Не удалось создать канал DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "Поставщик API",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Вы должны настроить URL-адрес webhook и токен проверки на портале разработчика Facebook с значениями, показанными ниже.",
          "WEBHOOK_URL": "URL вебхука",
          "WEBHOOK_VERIFICATION_TOKEN": "Токен авторизации Webhook"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Быстрая настройка через Meta",
          "DESC": "Вы будете перенаправлены на Meta для входа в ваш аккаунт WhatsApp Business. Наличие прав администратора сделает настройку быстрой и лёгкой.",
          "BENEFITS": {
            "EASY_SETUP": "Не требуется ручная настройка",
            "SECURE_AUTH": "Безопасная аутентификация на основе OAuth",
            "AUTO_CONFIG": "Автоматическая настройка вебхука и номера телефона"
          },
          "SUBMIT_BUTTON": "Подключиться через WhatsApp Business",
          "AUTH_PROCESSING": "Аутентификация через Meta",
          "WAITING_FOR_BUSINESS_INFO": "Пожалуйста, завершите настройку компании в окне Meta...",
          "PROCESSING": "Настройка вашего аккаунта WhatsApp Business",
          "CANCELLED": "Регистрация WhatsApp отменена",
          "WAITING_FOR_AUTH": "Ожидание аутентификации...",
          "INVALID_BUSINESS_DATA": "Получены некорректные данные компании от Facebook. Попробуйте ещё раз.",
          "SIGNUP_ERROR": "Произошла ошибка регистрации",
          "SDK_LOAD_ERROR": "Не удалось загрузить Facebook SDK. Попробуйте ещё раз.",
          "AUTH_NOT_COMPLETED": "Аутентификация не завершена. Пожалуйста, начните процесс заново.",
          "SUCCESS_FALLBACK": "Аккаунт WhatsApp Business успешно настроен",
          "RECONNECTED": "Канал WhatsApp успешно переподключён"
        },
        "API": {
          "ERROR_MESSAGE": "Не удалось сохранить канал WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Источник API",
        "DESC": "Интегрируйте с API каналом и начните поддерживать ваших клиентов.",
        "CHANNEL_NAME": {
          "LABEL": "имя источника",
          "PLACEHOLDER": "Пожалуйста введите имя источника",
          "ERROR": "Это поле обязательно"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL вебхука",
          "SUBTITLE": "Добавьте URL, на который вы бы хотели получать callback-события.",
          "PLACEHOLDER": "URL вебхука"
        },
        "SUBMIT_BUTTON": "Создайте источник API",
        "API": {
          "ERROR_MESSAGE": "Не удалось сохранить источник"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Канал Salesforce",
        "DESC": "Интегрируйтесь с каналом Salesforce и начните поддерживать своих клиентов.",
        "CHANNEL_NAME": {
          "LABEL": "Название канала",
          "PLACEHOLDER": "Пожалуйста, введите название канала",
          "ERROR": "Это поле обязательно"
        },
        "API_BASE_URL": {
          "LABEL": "URL API Salesforce",
          "SUBTITLE": "Настройте базовый URL для вашего экземпляра Salesforce.",
          "PLACEHOLDER": "URL API Salesforce"
        },
        "KEY_ID": {
          "LABEL": "ID ключа",
          "SUBTITLE": "ID ключа для вашего канала Salesforce.",
          "PLACEHOLDER": "ID КЛЮЧА"
        },
        "SECRET": {
          "LABEL": "Секрет",
          "SUBTITLE": "Секрет для вашего канала Salesforce.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Создать канал Salesforce",
        "API": {
          "ERROR_MESSAGE": "Не удалось сохранить канал Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "URL вебхука",
          "SUBTITLE": "Вам нужно настроить URL вебхука в Salesforce, указав URL, приведённый здесь."
        },
        "BEARER_TOKEN": {
          "TITLE": "Токен Bearer",
          "SUBTITLE": "Используйте этот токен Bearer для аутентификации при настройке вебхука в Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Переопределить отправителя email",
          "SUBTITLE": "Если задано, этот адрес электронной почты будет использоваться как отправитель для всех исходящих писем вместо исходного email диалога.",
          "PLACEHOLDER": "напр. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Источник Allegro",
        "DESC": "Подключите аккаунт продавца Allegro и отвечайте на сообщения его центра сообщений из контакт-центра.",
        "CHANNEL_NAME": {
          "LABEL": "Имя источника",
          "SUBTITLE": "Имя, которое операторы видят у этого источника.",
          "PLACEHOLDER": "Введите имя источника",
          "ERROR": "Это поле обязательно"
        },
        "SUBMIT_BUTTON": "Войти через Allegro",
        "API": {
          "ERROR_MESSAGE": "Не удалось подключиться к Allegro, пожалуйста, попробуйте ещё раз"
        },
        "SELLER_LOGIN": {
          "TITLE": "Вход в Allegro",
          "SUBTITLE": "Аккаунт продавца, сообщения которого этот источник читает и на которые отвечает."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Источник Kaufland",
        "DESC": "Отвечайте на сообщения в тикетах, которые покупатели отправляют вам на маркетплейсе Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Имя источника",
          "PLACEHOLDER": "Пожалуйста введите имя источника",
          "ERROR": "Это поле обязательно"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Client Key из 32 символов со страницы настроек API вашего аккаунта продавца Kaufland.",
          "PLACEHOLDER": "ключ из 32 символов",
          "ERROR": "Введите Client Key из 32 символов"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Secret Key из 64 символов, относящийся к Client Key. Kaufland показывает его один раз и никогда не возвращает на эту страницу.",
          "PLACEHOLDER": "ключ из 64 символов",
          "ERROR": "Введите Secret Key из 64 символов"
        },
        "SUBMIT_BUTTON": "Создать источник Kaufland",
        "API": {
          "ERROR_MESSAGE": "Не удалось сохранить источник Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Отключено",
          "MESSAGE": "Kaufland отклонил эти API-ключи. Введите Client Key и Secret Key заново, чтобы снова подключить этот источник."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Email источник",
        "DESC": "Интегрируйте ваш почтовый ящик.",
        "CHANNEL_NAME": {
          "LABEL": "имя источника",
          "PLACEHOLDER": "Пожалуйста введите имя источника",
          "ERROR": "Это поле обязательно"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Email куда ваши клиенты пишут запросы",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Создать источник email",
        "API": {
          "ERROR_MESSAGE": "Не удалось сохранить источник"
        },
        "FINISH_MESSAGE": "Начните пересылать свои письма на этот email."
      },
      "LINE_CHANNEL": {
        "TITLE": "Канал LINE",
        "DESC": "Интегрируйте канал LINE и начните общаться с вашими клиентами.",
        "CHANNEL_NAME": {
          "LABEL": "имя источника",
          "PLACEHOLDER": "Пожалуйста введите имя источника",
          "ERROR": "Это поле обязательно"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID канала LINE",
          "PLACEHOLDER": "ID канала LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Секрет канала LINE",
          "PLACEHOLDER": "Секрет канала LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Токен канала LINE",
          "PLACEHOLDER": "Токен канала LINE"
        },
        "SUBMIT_BUTTON": "Создать канал LINE",
        "API": {
          "ERROR_MESSAGE": "Не удалось сохранить канал LINE"
        },
        "API_CALLBACK": {
          "TITLE": "URL",
          "SUBTITLE": "Установите адрес webhook в приложении LINE, который указан здесь."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram канал",
        "DESC": "Интегрируйте Telegram канал и начните общаться с вашими клиентами.",
        "BOT_TOKEN": {
          "LABEL": "Токен авторизации",
          "SUBTITLE": "Настройте токен бота, который вы получили в Telegram BotFather.",
          "PLACEHOLDER": "Токен авторизации"
        },
        "SUBMIT_BUTTON": "Создать канал Telegram",
        "API": {
          "ERROR_MESSAGE": "Не удалось добавить канал Телеграм"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Телефонные звонки",
        "DESC": "Настройте, какие звонки будут отображаться в этом источнике.",
        "NAME": {
          "LABEL": "Название источника",
          "SUBTITLE": "Выберите легко узнаваемое название."
        },
        "PHONE_NUMBER": {
          "LABEL": "Номер телефона",
          "SUBTITLE": "Введите номера телефонов, принадлежащие этому источнику; вы сможете добавить ещё номера позже.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Создать источник телефонных звонков",
        "API": {
          "ERROR_MESSAGE": "Не удалось создать источник"
        }
      },
      "AUTH": {
        "TITLE": "Выберите источник",
        "DESC": "Чат поддерживает виджет чата, страницу Facebook, Whatsapp, Email и т. д., как канал связи с пользователями. Если вы хотите настроить пользовательский канал, вы можете создать его с помощью канала API. Выберите один канал из списка ниже, чтобы продолжить."
      },
      "AGENTS": {
        "TITLE": "Операторы",
        "DESC": "Здесь вы можете добавить операторов для управления только что созданным источником. Только эти операторы будут иметь доступ к вашему источнику. Операторы, которые не являются частью этого источника, не смогут видеть диалоги или отвечать на них. <br> <b>PS:</b> Если вам как администратору нужен доступ ко всем источникам, то вы должны добавить себя как операторы во все каналы, которые вы создаете.",
        "VALIDATION_ERROR": "Добавьте хотя бы одного агента в новый канал",
        "PICK_AGENTS": "Выберите агентов для канала"
      },
      "DETAILS": {
        "TITLE": "Настройки источника",
        "DESC": "Выберите страницу Facebook, которую вы хотите подключить к чату из списка. Для удобства ыы также можете указать имя вашего источника."
      },
      "FINISH": {
        "TITLE": "Готово!",
        "DESC": "Вы успешно подключили страницу Facebook к чату. В следующий раз когда покупатель напишет вашей странице, диалог автоматически отобразится здесь.<br>Мы также предоставляем вам скрипт виджета, который вы можете легко добавить на ваш сайт. Как только вы добавите его на сайт, клиенты смогут отправлять вам сообщения прямо с вашего сайта без помощи какого-либо внешнего инструмента и диалог появится прямо здесь, в чате.<br>Круто, да"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Выберите почтового провайдера",
        "DESCRIPTION": "Выберите поставщика электронной почты из списка ниже. Если вы не видите вашего почтового провайдера в списке, вы можете выбрать другую опцию провайдера и предоставить учетные данные IMAP и SMTP."
      },
      "MICROSOFT": {
        "TITLE": "Почта Microsoft",
        "DESCRIPTION": "Нажмите на кнопку Войти с помощью Microsoft, чтобы начать. Вы будете перенаправлены на страницу входа по электронной почте. Как только вы согласитесь с запрошенными правами, вы будете перенаправлены обратно на этап создания входящих сообщений.",
        "EMAIL_PLACEHOLDER": "Введите адрес электронной почты",
        "SIGN_IN": "Войти с помощью Microsoft",
        "ERROR_MESSAGE": "Произошла ошибка при подключении к Microsoft, попробуйте еще раз"
      },
      "GOOGLE": {
        "TITLE": "Google Почта",
        "DESCRIPTION": "Нажмите на кнопку Войти с помощью Google, чтобы начать. Вы будете перенаправлены на страницу входа в электронную почту. Как только вы согласитесь с запрошенными правами, вы будете перенаправлены обратно на этап создания источника.",
        "SIGN_IN": "Войти с помощью Google",
        "EMAIL_PLACEHOLDER": "Введите адрес электронной почты",
        "ERROR_MESSAGE": "Произошла ошибка при подключении к Google, пожалуйста, попробуйте еще раз"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Авторизуемся через Facebook...",
      "ERROR_FB_LOADING": "Ошибка загрузки SDK Facebook. Пожалуйста, отключите любые блокировщики рекламы и попробуйте снова из другого браузера.",
      "ERROR_FB_AUTH": "Что-то пошло не так, обновите страницу...",
      "ERROR_FB_UNAUTHORIZED": "Вы не авторизованы для выполнения этого действия. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Пожалуйста, убедитесь, что у вас есть доступ к странице Facebook с полными правами. Подробнее о ролях в Facebook можно прочитать <a href=\" https://www.facebook.com/help/187316341316631\">здесь</a>.",
      "ERROR_CHANNEL_CREATION": "Не удалось создать источник. Пожалуйста, попробуйте еще раз.",
      "CREATING_CHANNEL": "Создание источника...",
      "TITLE": "Настройка параметров источника",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Добавить операторов",
      "ADD_AGENTS": "Добавление операторов в ваш источник..."
    },
    "FINISH": {
      "TITLE": "Истоник готов!",
      "MESSAGE": "Теперь вы можете взаимодействовать с вашими клиентами через ваш новый канал. Удачной поддержки",
      "BUTTON_TEXT": "Перейти",
      "MORE_SETTINGS": "Больше параметров",
      "WEBSITE_SUCCESS": "Вы успешно создали источник-сайт. Скопируйте указанный ниже код и вставьте его на ваш сайт. В следующий раз, когда клиент напишет в чат, диалог автоматически появится здесь."
    },
    "REAUTH": "Войти заново",
    "VIEW": "Просмотр",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Настройки источника сохранены",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Автоназначение сохранено",
        "ERROR_MESSAGE": "Не удалось обновить настройки входящих сообщений. Пожалуйста, повторите попытку позже."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Включено",
        "DISABLED": "Выключено"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Включено",
        "DISABLED": "Выключено"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Включено",
        "DISABLED": "Выключено"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Имя отправителя",
        "SUB_TEXT": "Выберите имя, отображаемое клиенту, когда он получает письма от ваших агентов.",
        "FOR_EG": "Например:",
        "FRIENDLY": {
          "TITLE": "Дружелюбный",
          "FROM": "от",
          "SUBTITLE": "Добавьте имя агента, который отправил ответ в имени отправителя, чтобы сделать его дружелюбным."
        },
        "PROFESSIONAL": {
          "TITLE": "Профессиональный",
          "SUBTITLE": "Используйте только сконфигурированное бизнес-имя отправителя в заголовке электронной почты."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Настройте название вашей компании",
          "PLACEHOLDER": "Введите название вашей компании",
          "SAVE_BUTTON_TEXT": "Сохранить"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Включено",
        "DISABLED": "Выключено"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Включено",
        "DISABLED": "Выключено"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Нет"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Включено",
        "DISABLED": "Выключено"
      },
      "ENABLE_HMAC": {
        "LABEL": "Включить"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Включено",
        "DISABLED": "Выключено"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Включено",
        "DISABLED": "Выключено"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Включить синхронизацию входящих писем"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Включить собственный домен электронной почты (платная услуга)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Включить обработку комментариев Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Подпись HTML",
        "SUB_TEXT": "Эта подпись будет добавляться в конец каждого сообщения, отправленного из этого источника.",
        "HTML_CONTENT": "Код HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} будет заменено на имя оператора.\n{'{{'}email{'}}'} будет заменено на адрес электронной почты оператора, отправившего письмо.\n{'{{'}position{'}}'} будет заменено на должность оператора.\n{'{{'}custom_line{'}}'} будет заменено на произвольную строку оператора.\n{'{{'}email_signature_picture{'}}'} будет заменено на URL изображения подписи оператора (не тег изображения) — используйте его как источник изображения (атрибут src тега img).",
        "PREVIEW": "Предпросмотр"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Подписи по странам",
        "SUB_TEXT": "Ответ подписывается по стране покупателя.",
        "HELP": "Ответ подписывается по стране диалога: по магазину Kaufland, по маркетплейсу заказа Allegro, а если их нет — по языку, на котором пишет покупатель. Если страна неизвестна или для неё здесь нет подписи, используется подпись HTML выше. Маркетплейсы запрещают ссылки на ваш сайт и контактные данные, поэтому оставьте только приветствие и {'{{'}name{'}}'}.",
        "EMPTY": "У вас пока нет подписей для стран, поэтому в ответах используется HTML-подпись выше.",
        "COUNTRY": "Выберите страну",
        "ADD": "Добавить подпись для страны",
        "REMOVE": "Удалить"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Префикс набора номера",
        "PLACEHOLDER": "Введите префикс для корректной маршрутизации звонков (например, *99)",
        "HELP_TEXT": "Этот префикс будет автоматически добавляться перед номерами телефонов контактов при наборе из этого источника."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Текст кнопки «Решить позже»",
        "PLACEHOLDER": "напр. Эту тему решим по электронной почте. Сейчас хочу спросить о чём-то другом.",
        "HELP_TEXT": "Текст кнопки в виджете, с помощью которой посетитель выходит из текущей темы и задаёт другой вопрос. Если оставить поле пустым, будет использован текст по умолчанию на языке посетителя."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Автоматически откладывать пропущенные звонки на X минут",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Автоматически откладывает пропущенные звонки на указанное количество минут. Оставьте пустым или 0, чтобы отключить."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Решать пропущенный звонок после X неудачных обратных звонков",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Если на пропущенный звонок перезвонили X раз, а клиент так и не ответил, он автоматически решается, и к нему добавляется приватная заметка. Оставьте пустым или 0, чтобы отключить."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Подсказки вопросов",
        "SUB_TEXT": "Настройте заранее заданные вопросы, которые клиенты смогут использовать для общения с вашими операторами.",
        "QUESTIONS_LABEL": "Вопросы",
        "ADD_QUESTION": "Добавить вопрос",
        "REMOVE": "Удалить",
        "QUESTION_TEXT": "Текст, отображаемый в подсказке.",
        "QUESTION_TEXT_PLACEHOLDER": "Обязательно",
        "QUESTION_PAYLOAD": "Текст, отправляемый при нажатии.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Необязательно",
        "NO_BOT_MESSAGE": "Чтобы получать дополнительные подсказки ИИ, подключите бота.",
        "BOT_CONNECTED_MESSAGE": "Подсказки вопросов ИИ от бота можно включить в его",
        "BOT_SETTINGS_LINK": "настройках"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Альтернативные адреса электронной почты",
        "SUB_TEXT": "Дополнительные адреса, которые этот почтовый ящик должен считать своими при получении пересланной почты.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Добавить",
        "REMOVE": "Удалить",
        "EMPTY": "Альтернативные адреса электронной почты не настроены.",
        "HELP_TEXT": "Когда письмо приходит на один из этих адресов в качестве получателя, ответы будут отправляться с того же адреса в качестве отправителя. Убедитесь, что ваш исходящий SMTP-сервер разрешает отправку с этих адресов.",
        "SIGNATURE_LABEL": "Подпись",
        "PRIMARY_SIGNATURE": "Основная (по умолчанию)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Дополнительные подписи",
        "SUB_TEXT": "Задайте здесь дополнительные подписи, а затем назначьте их альтернативным адресам ниже.",
        "OPTION": "Подпись {number}",
        "ADD": "Добавить подпись",
        "REMOVE": "Удалить",
        "HELP_TEXT": "Когда ответ отправляется с альтернативного адреса, вместо подписи почтового ящика используется назначенная ему подпись. Альтернативные адреса, оставленные на «Основная (по умолчанию)», используют подпись почтового ящика."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "AVATAR_DELETE_BUTTON_TEXT": "Удалить аватар",
      "DELETE_REQUESTED_TOOLTIP": "Этот источник помечен для удаления",
      "RESTORE_BUTTON_TEXT": "Восстановить",
      "CONFIRM": {
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы точно хотите удалить ",
        "PLACE_HOLDER": "Пожалуйста, введите {inboxName} для подтверждения",
        "YES": "Да, удалить ",
        "NO": "Нет, не удалять "
      },
      "API": {
        "SUCCESS_MESSAGE": "Канал удален",
        "MARKED_FOR_DELETION_MESSAGE": "Источник помечен для удаления",
        "RESTORE_SUCCESS_MESSAGE": "Источник успешно восстановлен",
        "ERROR_MESSAGE": "Не удалось удалить канал. Пожалуйста, повторите попытку позже.",
        "RESTORE_ERROR_MESSAGE": "Не удалось восстановить источник. Попробуйте позже.",
        "AVATAR_SUCCESS_MESSAGE": "Аватар папки \"Входящие\" успешно удален",
        "AVATAR_ERROR_MESSAGE": "Не удалось удалить аватар связанный с каналом. Пожалуйста, повторите попытку позже."
      }
    },
    "TABS": {
      "SETTINGS": "Настройки",
      "COLLABORATORS": "Соавторы",
      "AUTOMATIC_PRIORITY": "Автоматический приоритет",
      "AUTOMATIC_LABELING": "Автоматическая разметка",
      "CONFIGURATION": "Настройки",
      "CAMPAIGN": "Кампании",
      "PRE_CHAT_FORM": "Форма, показываемая перед стартом диалога",
      "BUSINESS_HOURS": "Время работы",
      "WIDGET_BUILDER": "Конструктор виджетов",
      "BOT_CONFIGURATION": "Конфигурация бота",
      "SLA": "SLA"
    },
    "SETTINGS": "Настройки",
    "FEATURES": {
      "LABEL": "Возможности",
      "DISPLAY_FILE_PICKER": "Показывать выбор файла на виджете",
      "DISPLAY_EMOJI_PICKER": "Показывать эмодзи на виджете",
      "ALLOW_END_CONVERSATION": "Разрешить пользователям завершать диалог из виджета",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Показывать кнопку «Начать новый разговор» в шапке виджета",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Скрыть поле ввода, когда отображается кнопка начала нового диалога",
      "SHOW_HANDOFF_BUTTON": "Показывать кнопку «Передать оператору» в шапке виджета",
      "AUTO_CLOSE_OLD": "Отмечать все предыдущие звонки с того же номера как решённые после решения одного из них",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Автоматически назначать пропущенные звонки при совершении исходящего звонка",
      "USE_INBOX_AVATAR_FOR_BOT": "Использовать имя папки \"Входящие\" и аватар для бота",
      "ALLOW_OFFLINE_REPLY": "Разрешить операторам отправлять сообщения, когда контакт офлайн и продолжение переписки по email недоступно"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Скрипт",
      "MESSENGER_SUB_HEAD": "Поместите эту кнопку внутри тега <body>",
      "INBOX_AGENTS": "Операторы",
      "INBOX_TEAMS": "Команды",
      "INBOX_COOPERATORS": "Участники",
      "SELECT_PLACEHOLDER": "Выбрать",
      "AGENTS_OR_TEAMS_INFO": "Вы можете назначить либо операторов, либо команды — не то и другое одновременно.",
      "INBOX_AGENTS_SUB_TEXT": "Добавить или удалить агентов из этого источника",
      "AGENT_ASSIGNMENT": "Назначения для беседы",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Обновить настройки назначения для бесед",
      "UPDATE": "Обновить",
      "ENABLE_EMAIL_COLLECT_BOX": "Включить ящик сбора почты",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Включение или отключение ящик для сбора почты в новой беседе",
      "AUTO_ASSIGNMENT": "Включить автоназначение",
      "ENABLE_CSAT": "Включить CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Включить CSAT для каждого сообщения",
      "SENDER_NAME_SECTION": "Включить имя агента в электронной почте",
      "ENABLE_CSAT_SUB_TEXT": "Включить/выключить опрос CSAT(степень удовлетворенности пользователя) после завершения беседы",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Включить/выключить опрос CSAT для каждого сообщения, отправленного операторами",
      "SENDER_NAME_SECTION_TEXT": "Включить/выключить отображение имени Сотрудника в электронной почте, если отключено, он будет показывать бизнес-имя",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Включить непрерывность диалогов по электронной почте",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Диалоги будут продолжаться по электронной почте, если доступен контактный адрес электронной почты.",
      "RESPOND_FROM_EMAIL": "Отвечать с email",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Письма клиенту — как ответы, так и транскрипты диалога — отправляются через настройки SMTP выбранного почтового источника, с выбранного адреса (собственного адреса источника или одного из его алиасов), а ответы клиента поступают обратно через его адрес IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Транскрипты диалога отправляются через настройки SMTP выбранного почтового источника, с выбранного адреса (собственного адреса источника или одного из его алиасов), а ответы поступают обратно через его адрес IMAP.",
      "SHOW_WELCOME_SCREEN": "Показывать приветственный экран",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Показывать приветственный экран при открытии виджета. Если отключено, виджет сразу переходит к диалогу.",
      "AUTO_CLOSE_PENDING": "Автоматически решать чаты ИИ через (часов)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Автоматически решает чаты ИИ через X часов бездействия.",
      "LOCK_TO_SINGLE_CONVERSATION": "Заблокировать один диалог",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Включение или отключение нескольких диалогов для одного и того же контакта в этой папке «Входящие»",
      "INBOX_UPDATE_TITLE": "Настройки источника",
      "INBOX_UPDATE_SUB_TEXT": "Изменить настройки источника",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Включить или отключить автоматическое назначение новых разговоров к агентам, добавленным к этому источнику.",
      "HMAC_VERIFICATION": "Проверка личности пользователя",
      "HMAC_DESCRIPTION": "С помощью этого ключа вы можете сгенерировать секретный токен, который может быть использован для проверки личности ваших пользователей.",
      "HMAC_ROTATE": {
        "BUTTON": "Обновить ключ",
        "TITLE": "Обновить секретный ключ?",
        "WARNING": "Текущий ключ аннулируется в момент обновления.",
        "WARNING_DETAIL": "Периода совпадения нет, и восстановить ключ нельзя.",
        "IMPACT": "Ваши серверы должны подписывать пользователей новым ключом. Все, кто по-прежнему подписан старым ключом, не пройдут проверку. Если проверка личности обязательна, они не смогут начать диалог.",
        "CONFIRM": "Обновить ключ",
        "CANCEL": "Отменить",
        "SUCCESS": "Секретный ключ успешно обновлён",
        "ERROR": "Не удалось обновить секретный ключ, пожалуйста, попробуйте еще раз"
      },
      "HMAC_LINK_TO_DOCS": "Подробнее читайте здесь.",
      "HMAC_MANDATORY_VERIFICATION": "Принудительная проверка личности пользователя",
      "HMAC_MANDATORY_DESCRIPTION": "Если этот параметр включен, запросы, которые не могут быть проверены, будут отклонены.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Принудительно начинать новый разговор при каждой загрузке виджета",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Если включено, открытие виджета в новой вкладке или окне начинает новый разговор.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Забывать контакт при начале нового разговора",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Если отключено, новый разговор, начатый из виджета, сохраняет предыдущий контакт.",
      "INBOX_IDENTIFIER": "Идентификатор входящего канала",
      "INBOX_IDENTIFIER_SUB_TEXT": "Используйте токен `inbox_identifier` для аутентификации ваших клиентов API.",
      "FORWARD_EMAIL_TITLE": "Переслать на Email",
      "FORWARD_EMAIL_SUB_TEXT": "Начните пересылать свои письма на этот email.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Синхронизация email",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Включить автоматическую синхронизацию и загрузку входящих писем этого источника",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Собственный домен электронной почты",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Включите, чтобы использовать собственный домен электронной почты для исходящих писем",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Подробнее можно узнать здесь.",
      "FACEBOOK_COMMENTS_TITLE": "Комментарии Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Разрешить отправлять сообщения после завершения диалога",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Разрешить пользователям отправлять сообщения даже после того, как диалог будет завершен.",
      "WIDGET_STATUS_LABEL": "Статус виджета",
      "WIDGET_STATUS_ENABLED": "Включён",
      "WIDGET_STATUS_BUSINESS_HOURS": "Включён в рабочие часы",
      "WIDGET_STATUS_DISABLED": "Выключен",
      "WIDGET_STATUS_HELP_TEXT": "Управляйте тем, когда виджет показывается посетителям вашего сайта",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Обновить настройки формы для чата",
      "EXPLICIT_CSAT_LOCALE": "Язык опроса CSAT и писем",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Выберите язык для всех писем клиентам, включая опросы CSAT, транскрипты диалогов и уведомления по email",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Наследовать от аккаунта",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Подключение WhatsApp",
        "SUBTITLE": "Как этот почтовый ящик подключён к WhatsApp.",
        "PROVIDER": "Провайдер",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Подключено через встроенную регистрацию Meta",
        "STATUS": "Статус",
        "CONNECTED": "Подключено",
        "RECONNECT_HINT": "Нажмите «Подключить заново» в уведомлении выше.",
        "PHONE_NUMBER": "Номер телефона",
        "BUSINESS_ACCOUNT": "ID аккаунта WhatsApp Business",
        "OPEN_MANAGER": "Открыть в WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID номера телефона",
        "TEMPLATES": "Шаблоны сообщений",
        "TEMPLATES_COUNT": "Одобрено {approved} из {total}",
        "TEMPLATES_SYNCED": "Последняя синхронизация: {date}",
        "TEMPLATES_NOT_SYNCED": "Ещё не синхронизированы",
        "MANAGE_TEMPLATES": "Управлять шаблонами"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Центр поддержки",
      "PLACEHOLDER": "Выберите справочный центр",
      "SELECT_PLACEHOLDER": "Выберите справочный центр",
      "REMOVE": "Удалить справочный центр",
      "SUB_TEXT": "Прикрепить справочный центр с помощью папки \"Входящие\""
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Авто распределение лимита",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Пожалуйста, введите значение больше 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Ограничьте максимальное количество диалогов из этого почтового ящика, которые могут быть автоматически назначены агенту"
    },
    "SLA": {
      "TITLE": "Политики SLA",
      "SUB_TEXT": "Настройте время ответа и решения по SLA для каждого уровня приоритета диалога.",
      "LOADING": "Загрузка политик SLA...",
      "FIELDS": {
        "ACTIVE": "Активно",
        "TICKET_PRIORITY": "Приоритет тикета",
        "FIRST_RESPONSE_TIME": "Время первого ответа",
        "EVERY_RESPONSE_TIME": "Время каждого ответа",
        "RESOLUTION_TIME": "Время решения",
        "PLACEHOLDER": "напр. 1ч 30м"
      },
      "API": {
        "SUCCESS_MESSAGE": "Политики SLA успешно обновлены.",
        "ERROR_MESSAGE": "Не удалось обновить политики SLA. Попробуйте ещё раз."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Автоматический приоритет",
      "SUB_TEXT": "Настройте автоматическое назначение приоритета на основе содержимого диалога.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Уведомление о списании",
        "MESSAGE": "Каждая оценка приоритета оплачивается. Ознакомьтесь с деталями вашего тарифа для получения информации о ценах."
      },
      "MODE": {
        "OFF": "Выключено",
        "ALL_MESSAGES": "Включено для всех входящих сообщений",
        "FIRST_MESSAGE": "Включено только для первого входящего сообщения"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Настройка уровней приоритета",
        "SUB_TEXT": "Настройте, какие уровни приоритета должны быть включены, и их описания. Укажите чёткие критерии, чтобы ИИ мог определить, когда назначать этот приоритет."
      },
      "DESCRIPTION_LABEL": "Описание",
      "DESCRIPTION_PLACEHOLDER": "Опишите диалоги, которые нужно отмечать приоритетом {priority}",
      "SET_AS_DEFAULT": "Установить как приоритет по умолчанию",
      "MULTIPLE_DEFAULTS_WARNING": "Только один уровень приоритета может быть установлен по умолчанию. Снимите отметку с остальных."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Автоматическая разметка",
      "SUB_TEXT": "Настройте автоматическое назначение меток на основе содержимого диалога.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Уведомление о списании",
        "MESSAGE": "Каждая оценка разметки оплачивается. Ознакомьтесь с деталями вашего тарифа для получения информации о ценах."
      },
      "MODE": {
        "OFF": "Выключено",
        "CONVERSATION_OPEN": "При открытии диалога",
        "CONVERSATION_CLOSE": "При закрытии диалога",
        "ALL_MESSAGES": "При каждом сообщении — независимо от статуса",
        "FIRST_MESSAGE": "При первом сообщении — независимо от статуса"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Настройка меток",
        "SUB_TEXT": "Настройте, какие метки должны быть доступны для автоматического назначения, и их описания. Укажите чёткие критерии, чтобы ИИ мог определить, когда применять эту метку."
      },
      "DESCRIPTION_LABEL": "Описание",
      "DESCRIPTION_PLACEHOLDER": "Опишите диалоги, которые нужно помечать меткой {label}. Если оставить пустым, будет использовано описание метки.",
      "NO_LABELS_MESSAGE": "Метки не найдены. Сначала создайте метки, чтобы включить автоматическую разметку.",
      "CREATE_LABELS_LINK": "Создать метки"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Войти заново",
      "SUBTITLE": "Ваше подключение к Facebook истекло. Пожалуйста, переподключитесь к Facebook для продолжения работы",
      "MESSAGE_SUCCESS": "Переподключение выполнено",
      "MESSAGE_ERROR": "Произошла ошибка, попробуйте еще раз"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Предварительные формы позволяют получить информацию о пользователе, прежде чем они начнут разговор.",
      "SET_FIELDS": "Поля отображаемые перед началом диалога",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Поля",
        "LABEL": "Метка",
        "PLACE_HOLDER": "Вариант ввода в поле",
        "KEY": "Ключ",
        "TYPE": "Тип",
        "REQUIRED": "Обязательно"
      },
      "ENABLE": {
        "LABEL": "Включить форму сбора предварительной информации",
        "OPTIONS": {
          "ENABLED": "Да",
          "DISABLED": "Нет"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Сообщение отображаемое перед началом диалога",
        "PLACEHOLDER": "Это сообщение будет отображаться вместе с формой для пользователя"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Посетители должны указать свое имя и адрес электронной почты перед началом общения"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Настройте ваши рабочие часы",
      "SUBTITLE": "Настройте ваши рабочие часы для общения через виджет на сайте",
      "WEEKLY_TITLE": "Укажите ваши рабочие часы",
      "TIMEZONE_LABEL": "Выберите часовой пояс",
      "UPDATE": "Обновить настройки часов работы",
      "TOGGLE_AVAILABILITY": "Включить доступность бизнеса для этого входящего канала",
      "UNAVAILABLE_MESSAGE_LABEL": "Сообщение для посетителей о недоступности",
      "TOGGLE_HELP": "Включение доступности для бизнеса покажет часы работы в виджете онлайн общения, даже если все менеджеры не в сети. Вне доступных часов работы - посетители могут быть предупреждены сообщением и формой предварительного чата.",
      "DAY": {
        "ENABLE": "Я работаю в этот день",
        "UNAVAILABLE": "Я не работаю в этот день",
        "HOURS": "часы",
        "VALIDATION_ERROR": "Время начала должно предшествовать времени окончания.",
        "CHOOSE": "Выбрать"
      },
      "ALL_DAY": "Весь день",
      "SAVE_TO_ALL": "Сохранить для всех источников",
      "SAVE_TO_ALL_TITLE": "Копировать рабочие часы",
      "SAVE_TO_ALL_CONFIRM": "Настройки из этой формы (переключатель доступности, сообщение об отсутствии, часовой пояс и рабочие часы) будут скопированы во все остальные источники, кроме почтовых и телефонных. Вы уверены, что хотите продолжить?",
      "SAVE_TO_ALL_CANCEL": "Отменить",
      "SAVE_TO_ALL_YES": "Да, скопировать для всех",
      "SAVE_TO_ALL_SUCCESS": "Рабочие часы успешно скопированы во все остальные источники",
      "SAVE_TO_ALL_ERROR": "Не удалось скопировать рабочие часы в другие источники"
    },
    "PHONE": {
      "TITLE": "Настройки телефона",
      "SUBTITLE": "Настройте, какие звонки будут отображаться в этом источнике.",
      "UPDATE": "Сохранить настройки",
      "EDIT": {
        "SUCCESS_MESSAGE": "Настройки телефона обновлены"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Номера телефонов",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Настроить параметры IMAP",
      "NOTE_TEXT": "Для включения SMTP, настройте IMAP.",
      "UPDATE": "Обновить настройки IMAP",
      "TOGGLE_AVAILABILITY": "Включить конфигурацию IMAP для этого ящика",
      "TOGGLE_HELP": "Включение IMAP поможет пользователю получать электронную почту",
      "EDIT": {
        "SUCCESS_MESSAGE": "Настройки IMAP успешно обновлены",
        "ERROR_MESSAGE": "Невозможно обновить настройки IMAP"
      },
      "ADDRESS": {
        "LABEL": "Адрес",
        "PLACE_HOLDER": "Адрес (например, imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Порт",
        "PLACE_HOLDER": "Порт"
      },
      "LOGIN": {
        "LABEL": "Вход",
        "PLACE_HOLDER": "Вход"
      },
      "PASSWORD": {
        "LABEL": "Пароль",
        "PLACE_HOLDER": "Пароль"
      },
      "ENABLE_SSL": "Включить SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Повторите авторизацию учетной записи MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Настроить параметры SMTP",
      "UPDATE": "Обновить настройки SMTP",
      "TOGGLE_AVAILABILITY": "Включить SMTP конфигурацию для этого ящика",
      "TOGGLE_HELP": "Включение SMTP поможет пользователю отправлять почту",
      "EDIT": {
        "SUCCESS_MESSAGE": "Настройки SMTP успешно обновлены",
        "ERROR_MESSAGE": "Невозможно обновить настройки SMTP"
      },
      "ADDRESS": {
        "LABEL": "Адрес",
        "PLACE_HOLDER": "Адрес (например, smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Порт",
        "PLACE_HOLDER": "Порт"
      },
      "LOGIN": {
        "LABEL": "Вход",
        "PLACE_HOLDER": "Вход"
      },
      "PASSWORD": {
        "LABEL": "Пароль",
        "PLACE_HOLDER": "Пароль"
      },
      "DOMAIN": {
        "LABEL": "Домен",
        "PLACE_HOLDER": "Домен"
      },
      "ENCRYPTION": "Шифрование",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Режим проверки Open SSL",
      "AUTH_MECHANISM": "Авторизация"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Доставляемость почты (DNS)",
      "SUB_TITLE": "Мы проверяем записи SPF, DKIM, DMARC и MX домена {domain} каждый рабочий день. Если из-за чего-то принимающие серверы отклоняют ваши ответы или отправляют их в спам, администраторы получают письмо с описанием исправления.",
      "RUN": "Запустить проверку",
      "RUN_SUCCESS": "Проверка DNS завершена",
      "RUN_ERROR": "Не удалось выполнить проверку DNS, попробуйте ещё раз",
      "NOT_CHECKED": "Ещё не проверялось.",
      "CHECKED_AT": "Последняя проверка: {time}.",
      "DNS_UNAVAILABLE": "При последней проверке DNS-серверы домена не ответили. Ниже показан результат предыдущей проверки.",
      "SENDER": {
        "SMTP": "Ответы отправляются через {host}.",
        "PLATFORM": "Ответы отправляются через наши почтовые серверы."
      },
      "STATUS": {
        "OK": "Все записи в порядке",
        "WARNING": "Некоторые записи можно улучшить",
        "ERROR": "Ответы могут не доходить до получателей",
        "UNKNOWN": "Неизвестно"
      },
      "SEVERITY": {
        "ERROR": "Проблема",
        "WARNING": "Предупреждение"
      },
      "FIX": "Исправьте это с помощью следующей DNS-записи:",
      "RECORD_TYPE": "Тип",
      "RECORD_HOST": "Имя",
      "RECORD_VALUE": "Значение",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Отсутствует запись SPF",
          "DESCRIPTION": "Домен не указывает, каким серверам разрешено отправлять его почту. Из-за этого многие почтовые серверы считают ваши ответы спамом. Добавьте запись SPF, разрешающую {sender}."
        },
        "spf_multiple": {
          "TITLE": "У домена несколько записей SPF: {count}",
          "DESCRIPTION": "У домена может быть только одна запись SPF. Если их больше, принимающие серверы игнорируют SPF и часто отклоняют письма. Объедините их в одну запись."
        },
        "spf_not_authorized": {
          "TITLE": "SPF не разрешает сервер, который отправляет ваши ответы",
          "DESCRIPTION": "Ваши ответы отправляются через {sender}, но в записи SPF домена его нет. Текущая запись: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Записи SPF требуется слишком много DNS-запросов",
          "DESCRIPTION": "Принимающие серверы прекращают проверку SPF после {limit} DNS-запросов, а {sender}, через который отправляются ваши ответы, встречается только после {lookups}. Ваши ответы не проходят проверку SPF. Переместите {sender} в начало записи и удалите include, которые домен больше не использует."
        },
        "spf_lookups_others": {
          "TITLE": "Часть отправителей в записи SPF выходит за лимит запросов",
          "DESCRIPTION": "Записи SPF требуется {lookups} DNS-запросов, а принимающие серверы останавливаются после {limit}. Ваши ответы проверяются вовремя и проходят, но письма от этих отправителей не проходят проверку SPF: {senders}. Удалите include, которые домен больше не использует."
        },
        "spf_malformed": {
          "TITLE": "Запись SPF повреждена",
          "DESCRIPTION": "Принимающие серверы не могут прочитать запись SPF домена, поэтому она не защищает ваши ответы. Проблема в: {terms}. Замените запись исправленной."
        },
        "dkim_missing": {
          "TITLE": "Подпись DKIM не настроена",
          "DESCRIPTION": "Ключ DKIM не найден по адресу {selectors}. Без него ваши ответы не подписываются и чаще попадают в спам. Включите подпись DKIM для домена у вашего почтового провайдера."
        },
        "dmarc_missing": {
          "TITLE": "Отсутствует запись DMARC",
          "DESCRIPTION": "Крупные почтовые сервисы, такие как Gmail и Microsoft, ожидают наличия записи DMARC. Без неё ваши ответы чаще попадают в спам."
        },
        "dmarc_fails": {
          "TITLE": "DMARC предписывает получателям отклонять ваши ответы",
          "DESCRIPTION": "Политика DMARC домена — «{policy}», а ваши ответы не проходят ни SPF, ни DKIM, поэтому получатели отклоняют их или отправляют в спам. Исправьте SPF и DKIM, описанные выше."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC блокирует ответы, отправленные через наши почтовые серверы",
          "DESCRIPTION": "Этот почтовый ящик отправляет ответы через наши почтовые серверы, но политика DMARC домена — «{policy}», поэтому получатели отклоняют их или отправляют в спам. Настройте для этого ящика SMTP вашего собственного почтового сервера."
        },
        "mx_missing": {
          "TITLE": "У домена нет записи MX",
          "DESCRIPTION": "Без записи MX никто не может отправлять письма на домен, поэтому клиенты не смогут ответить на ваши письма."
        }
      }
    },
    "NOTE": "Примечание: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Аватар сайта",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Аватар успешно удален",
              "ERROR_MESSAGE": "Произошла ошибка, попробуйте еще раз"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Имя сайта",
          "PLACE_HOLDER": "Введите имя вашего сайта (например: Acme Inc)",
          "ERROR": "Пожалуйста, правильно введите имя веб-сайта"
        },
        "WELCOME_HEADING": {
          "LABEL": "Заголовок приветствия",
          "PLACE_HOLDER": "Привет!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Текст приветствия",
          "PLACE_HOLDER": "Связаться с нами просто! Напишите нам, или задайте вопрос."
        },
        "REPLY_TIME": {
          "LABEL": "Время ответа",
          "IN_A_FEW_MINUTES": "Через несколько минут",
          "IN_A_FEW_HOURS": "Через несколько часов",
          "IN_A_DAY": "Через день"
        },
        "WIDGET_COLOR_LABEL": "Цвет виджета",
        "WIDGET_BUBBLE_POSITION_LABEL": "Позиция конструктора виджетов",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Максимальная высота непрочитанных сообщений (px)",
          "PLACE_HOLDER": "Без ограничений",
          "HELP_TEXT": "Ограничьте максимальную высоту всплывающего окна непрочитанных сообщений в пикселях. Оставьте пустым для поведения по умолчанию (без ограничений)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Тип рамки для виджета",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Пообщайтесь с нами",
          "LABEL": "Название виджета",
          "PLACE_HOLDER": "Пообщайтесь с нами"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Обновить настройки виджета",
          "API": {
            "SUCCESS_MESSAGE": "Настройки виджета успешно обновлены",
            "ERROR_MESSAGE": "Не удается обновить настройки виджета"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Предпросмотр",
          "SCRIPT": "Скрипт"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Слева",
          "RIGHT": "Справа"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Стандартный",
          "EXPANDED_BUBBLE": "Расширенная рамка сообщений"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "По умолчанию",
        "CHAT": "Чат"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Обычно отвечаем в течение нескольких минут",
        "IN_A_FEW_HOURS": "Обычно отвечаем в течение нескольких часов",
        "IN_A_DAY": "Обычно отвечаем в течение дня"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Начать диалог",
        "CHAT_INPUT_PLACEHOLDER": "Введите сообщение"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Мы в сети",
          "OFFLINE": "В данный момент мы отсутствуем"
        },
        "USER_MESSAGE": "Хай",
        "AGENT_MESSAGE": "Привет"
      },
      "BRANDING_TEXT": "Работает на JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Другие провайдеры"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Сайт",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Источник API",
      "PHONE": "Телефон SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
